import action from "../helpers/rest-client";

export class ErrorSession extends Error { }

class Session {
  public async new(payload) {
    const formData = new FormData();
    const data = {};

    for (let key in payload) {
      const currentElement = payload[key];

      if (
        (key === "cover_pic" || key === "speaker_profile_pic") &&
        currentElement
      ) {
        currentElement.forEach(async (element) => {
          // Verificar si es un archivo nuevo o un archivo existente
          if (element instanceof File) {
            formData.append(key, element, element.name);
          } else if (element instanceof Blob) {
            formData.append(key, element, `${key}_file`);
          } else if (element && typeof element === 'object' && element.id) {
            // Es un archivo existente, agregarlo al data como ID
            if (!data[key]) {
              data[key] = [];
            }
            data[key].push(element.id);
          }
        });
      } else {
        data[key] = currentElement;
      }
    }

    formData.append("data", JSON.stringify(data));

    return action
      .Post({
        url: `/api/session`,
        body: formData,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async update(payload) {
    const { id: idSession, ...rest } = payload;
    const formData = new FormData();
    const data = {};

    for (let key in rest) {
      const currentElement = payload[key];

      if (
        (key === "cover_pic" || key === "speaker_profile_pic") &&
        currentElement
      ) {
        currentElement.forEach(async (element) => {
          // Verificar si es un archivo nuevo
          if (element instanceof File) {
            formData.append(key, element, element.name);
          } else if (element instanceof Blob) {
            formData.append(key, element, `${key}_file`);
          } else if (element && element?.url) {
            // Archivo existente que necesita ser re-enviado
            const file = await fetch(element?.url)
              .then((res) => res.blob())
              .then((blob) => {
                const extension = element?.url?.split(".").pop();
                return new File([blob], `${key}.${extension}"`, {
                  type: `image/${extension}`,
                });
              });

            formData.append(key, file, file.name);
          } else if (element && typeof element === 'object' && element.id) {
            // Es un archivo existente, agregarlo al data como ID
            if (!data[key]) {
              data[key] = [];
            }
            data[key].push(element.id);
          }
        });
      } else {
        data[key] = currentElement;
      }
    }

    formData.append("data", JSON.stringify(data));

    return action
      .Put({
        url: `/api/session/${idSession}`,
        body: formData,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async delete({ idSession, action_notification_message, notify_action }) {
    return action
      .Post({
        url: `/api/session/delete/${idSession}`,
        body: {
          idSession,
          action_notification_message,
          notify_action
        }
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async deleteBulk({ idSessions, action_notification_message, notify_action }) {
    return action
      .Post({
        url: `/api/session/delete/bulk`,
        body: {
          idSessions,
          action_notification_message,
          notify_action
        }
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async getOne(payload) {
    const { idSession } = payload;
    return action
      .Get({
        url: `/api/session/${idSession}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error: error.response.data };
      });
  }

  public async getAll(payload) {
    const { idGroup } = payload;
    return action
      .Get({
        url: `/api/session?group_id=${idGroup}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async deleteFile(payload) {
    const { idFile } = payload;

    return action
      .Del({
        url: `/api/session/file/${idFile}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async deleteMediaFile(payload) {
    const { idFile } = payload;

    return action
      .Del({
        url: `/api/session/media-file/${idFile}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async shareSessionInTelegram({ id }) {
    return action
      .Post({
        url: `/api/session/share-in-telegram`,
        body: { session_id: id },
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }

  public async duplicate(payload) {
    const formData = new FormData();
    const { idSession, ...sessionData } = payload;
    const data = {};

    for (let key in sessionData) {
      const currentElement = sessionData[key];

      if (
        (key === "cover_pic" || key === "speaker_profile_pic") &&
        currentElement &&
        currentElement.length > 0
      ) {
        // Verificar si es un archivo nuevo (File/Blob) o un ID existente
        const element = currentElement[0];

        if (element instanceof File || element instanceof Blob) {
          // Es un archivo nuevo, subirlo
          const fileName = element instanceof File ? element.name : 'file';
          formData.append(key, element, fileName);
        } else if (element && typeof element === 'object' && element.id) {
          // Es un media file existente, enviar solo el ID
          data[key] = element.id;
        }
      } else {
        data[key] = currentElement;
      }
    }

    formData.append("data", JSON.stringify(data));
    formData.append("duplicatedSessionId", idSession.toString());

    return action
      .Post({
        url: `/api/session/duplicate`,
        body: formData,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const session = new Session();
export default session;
